import axios from "axios";
import { getLocalAccessToken, getLocalRefreshToken, updateLocalAccessToken } from "./token.service";

const API_URL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
    baseURL: API_URL,
    headers: {
        "Content-Type": "application/json",
    },
});

// Request Interceptor
axiosInstance.interceptors.request.use(
    (config) => {
        const token = getLocalAccessToken();
        if (token) {
            config.headers["Authorization"] = token
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// Response Interceptor
axiosInstance.interceptors.response.use(
    (response) => response,
    async (error) => {
        const originalConfig = error.config;

        // Redirect on refresh token invalid
        if (error.response?.data?.message === "Refresh token is not in database!") {
            window.location = "/lockscreen";
            return Promise.reject(error);
        }

        // Handle Access Token expiration
        if (error.response?.status === 401 && !originalConfig._retry) {
            originalConfig._retry = true;

            try {
                const refreshToken = getLocalRefreshToken();

                if (!refreshToken) {
                    window.location = "/lockscreen";
                    return Promise.reject(error);
                }

                const { data } = await axiosInstance.post("refresh-token", { refreshToken });
                if(data){
                    const updatedUserInfo = {
                        customer_id: data.customer_id,
                        customer_name: data.customer_name,
                        customer_contact_number: data.customer_contact_number,
                        customer_firebase_document_id: data.customer_firebase_document_id,
                        token: data.token,
                        refreshToken: data.refreshToken,
                    };

                    updateLocalAccessToken(updatedUserInfo);

                    // Retry the original request with the new token
                    originalConfig.headers["Authorization"] = `${data.token}`;
                    return axiosInstance(originalConfig);
                }else{
                    window.location = "/lockscreen";
                    return Promise.reject(error);
                }
            } catch (refreshError) {
                // Redirect to lockscreen if token refresh fails
                window.location = "/lockscreen";
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);

export default axiosInstance;